import { cloneDeep } from 'lodash';
import { version } from '../package.json';
import parseLocale from '@/lib/parseLocale';

const config = {
  env: process.env.NODE_ENV,
  version,
  get checkVersion() {
    return config.env !== 'development';
  },
  backend: {
    get baseUrl() {
      if (config.env === 'development') {
        return 'http://localhost:3000';
      }

      return `${window.location.origin}/api`;
    },
    cors: {
      get credentials() {
        return config.env === 'development';
      },
    },
  },
  i18n: {
    get debug() {
      return config.env === 'development';
    },
    fallbackLng: 'en',
    ns: 'default',
    defaultNS: 'default',
    fallbackNS: 'default',
    backend: {
      get loadPath() {
        return `${config.backend.baseUrl}/locales/{{lng}}/{{ns}}`;
      },
      parse: parseLocale,
    },
    saveMissing: true,
    missingKeyHandler() {
      // do nothing

      // With `saveMissing: true` and no `missingKeyHandler` set this would call
      // the default handler of the i18next-xhr-backend plugin. However, we use
      // a custom handler which is bound to the missingKey event in main.js.
    },
  },
};

export default cloneDeep(config);
